import { Grid } from '@mui/material';
import { Fragment } from 'react';
import { productionLinks, filterNavLinksForAccess } from '../../helpers';
import { PortalLayout, ExternalLinkPortalCard, LinkPortalCard } from '../../components';

export const ProductionProtal = () => {
  return (
    <PortalLayout title="Production">
      {({ userContext, featureFlags, availableLinks }) => {
        return (
          <>
            {filterNavLinksForAccess(
              productionLinks,
              userContext,
              featureFlags,
              availableLinks
            ).map((link, i) => {
              return (
                <Fragment key={`${i}`}>
                  <Grid xs={12} sm={6} md={4} item>
                    {link.featureFlag && !featureFlags[link.featureFlag] ? (
                      <ExternalLinkPortalCard link={link} />
                    ) : (
                      <LinkPortalCard link={link} />
                    )}
                  </Grid>
                </Fragment>
              );
            })}
          </>
        );
      }}
    </PortalLayout>
  );
};
